// Source unique des informations légales du site (CGV, confidentialité, mentions légales, paiement).
// Voir docs/superpowers/specs/2026-10-07-w19b-conformite-design.md

export type Mediator = {
  name: string;
  address: string;
  website: string;
};

export const LEGAL = {
  seller: {
    name: 'Mathieu Caron',
    status: 'Entreprise individuelle',
    siret: '511 972 804 00021',
    address: '40 rue Alexandre Dumas, 75011 Paris',
    email: 'nouscontacter@mp3randomselector.fr',
  },
  vat: 'TVA non applicable, art. 293 B du CGI',
  // Identifie les CGV acceptées au paiement (preuve). À changer à chaque modification des CGV.
  termsVersion: '2026-10-07',
  satisfactionGuaranteeDays: 30,
  retention: {
    activationLogsMonths: 6,
    billingYears: 10,
  },
  // Médiateur de la consommation : à renseigner avant la mise en production des CGV.
  // Tant que la valeur est null, aucune section médiateur n'est affichée.
  mediator: null as Mediator | null,
} as const;
